"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHideAppPromoBannerUntilDate = exports.isAppPromoBannerVisible = exports.getHideAppPromoBannerUntilDate = exports.APP_PROMO_LOCAL_STORAGE_KEY = void 0;
const APP_PROMO_LOCAL_STORAGE_KEY = exports.APP_PROMO_LOCAL_STORAGE_KEY = 'hideAppPromoBannerUntil';
const getHideAppPromoBannerUntilDate = () => {
  const hideAppPromoBannerUntilFromLocalStorage = localStorage.getItem(APP_PROMO_LOCAL_STORAGE_KEY);
  const hideAppPromoBannerUntil = hideAppPromoBannerUntilFromLocalStorage ? new Date(hideAppPromoBannerUntilFromLocalStorage) : null;
  return hideAppPromoBannerUntil;
};
exports.getHideAppPromoBannerUntilDate = getHideAppPromoBannerUntilDate;
const setHideAppPromoBannerUntilDate = () => {
  const dateNow = new Date();
  dateNow.setMonth(dateNow.getMonth() + 1);
  localStorage.setItem(APP_PROMO_LOCAL_STORAGE_KEY, dateNow.toISOString());
};
exports.setHideAppPromoBannerUntilDate = setHideAppPromoBannerUntilDate;
const isAppPromoBannerVisible = ({
  data,
  userOs
}) => {
  const hideAppPromoBannerUntil = getHideAppPromoBannerUntilDate();
  const dateNow = new Date();
  return Boolean(userOs && (!hideAppPromoBannerUntil || hideAppPromoBannerUntil.toString() === 'Invalid Date' || hideAppPromoBannerUntil < dateNow) && data?.appName && data.bannerLink);
};
exports.isAppPromoBannerVisible = isAppPromoBannerVisible;